import { ActionType, getType } from "typesafe-actions";
import * as actions from "../actions/settingsAction";
import { isElectron } from "src/utils/miscUtils";

export interface ISettingsState {
    colorMode: string;
    preferredProcessingMode?: 'local' | 'cloud';
}

export const initialSettingsState: ISettingsState = {
    colorMode: 'light',
    // Default to 'local' for Electron/desktop, undefined for others
    preferredProcessingMode: isElectron() ? 'local' : undefined,
};

export const SettingsReducer = (
    state: ISettingsState = initialSettingsState,
    action: ActionType<typeof actions>
): ISettingsState => {
    switch (action.type) {
        case getType(actions.setAppColorMode):
            return {
                ...state,
                colorMode: action.payload
            };
        case getType(actions.setPreferredProcessingMode):
            return {
                ...state,
                preferredProcessingMode: action.payload
            };
        default:
            return state;
    }
};
